import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importSpendingLimitAnimation = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "SpendingLimitAnimation" */
                '@perpay-web/fintech/components/base/SpendingLimitAnimation/SpendingLimitAnimation'
            ),
    );
